import { createSlice } from "@reduxjs/toolkit";
import { dummyCaptains } from "src/constants/dummyCaptains";

const initialState = {
  captainsList: dummyCaptains, // ✅ ALWAYS AVAILABLE
};

const captainsSlice = createSlice({
  name: "captains",
  initialState,
  reducers: {
    setCaptainsList: (state, action) => {
      state.captainsList = action.payload || dummyCaptains;
    },
  },
});

export const { setCaptainsList } = captainsSlice.actions;
export default captainsSlice.reducer;